<div style="min-width: 100px" class="f-12">Filter by:</div>
<ng-container *ngFor="let filter of filters; let i = index">
  <ng-container *ngIf="!Array.isArray(filter)">
    <nz-row [nzGutter]="16" [nzAlign]="'bottom'" class="rowGap">
      <nz-col [nzSpan]="24" class="text-center">
        <ng-container *ngIf="i == 0"> </ng-container>
        <ng-container *ngIf="i !== 0">
          <nz-switch
            style="min-width: 100px"
            class="w_100 mt-15"
            [(ngModel)]="initialSetFilter"
            nzCheckedChildren="AND"
            nzUnCheckedChildren="OR"
            (ngModelChange)="changeOperatorAdd($event, i)"
            [disabled]="i > 1"
          ></nz-switch>
        </ng-container>
      </nz-col>
      <nz-col [nzSpan]="12">
        <nz-select
          class="w_100"
          [ngModel]="getCombinedValue(filter)"
          nzPlaceHolder="Select field"
          (ngModelChange)="onCombinedFieldSelection($event, filter)"
          nzAllowClear
          [nzDropdownRender]="customDropdownTemplate"
          [nzNotFoundContent]="''"
          [nzShowSearch]="false"
        >
          <nz-option
            *ngIf="getCombinedValue(filter)"
            [nzLabel]="getCombinedValue(filter)"
            [nzValue]="getCombinedValue(filter)"
            nzHide
          >
          </nz-option>
        </nz-select>

        <!-- Your existing custom dropdown template -->
        <ng-template #customDropdownTemplate>
          <!-- Search input -->
          <div style="padding: 8px; border-bottom: 1px solid #f0f0f0">
            <input
              #searchInput
              nz-input
              placeholder="Search fields..."
              [(ngModel)]="searchTerm"
              (input)="onSearchChange($event)"
              style="width: 100%"
            />
          </div>

          <!-- Dropdown content -->
          <div style="max-height: 200px; overflow-y: auto">
            <!-- Main Entity Group -->
            <div *ngIf="shouldShowEntity(default_data?.entity?.display_name)">
              <div class="entity-header">
                {{ default_data?.entity?.display_name }}
              </div>

              <!-- Priority fields -->
              <div
                *ngFor="let field of getFilteredMainEntityPriorityFields()"
                class="field-option priority-field"
                (click)="
                  selectFieldWithFilter(
                    default_data?.entity?.name,
                    field.name,
                    field.label,
                    filter
                  )
                "
                [class.selected]="
                  isSelected(default_data?.entity?.name, field.name, filter)
                "
              >
                <span class="star">★</span> {{ field.label }}
              </div>

              <!-- Non-priority fields (when expanded) -->
              <div *ngIf="expandedEntities[default_data?.entity?.name]">
                <div
                  *ngFor="let field of getFilteredMainEntityNonPriorityFields()"
                  class="field-option"
                  (click)="
                    selectFieldWithFilter(
                      default_data?.entity?.name,
                      field.name,
                      field.label,
                      filter
                    )
                  "
                  [class.selected]="
                    isSelected(default_data?.entity?.name, field.name, filter)
                  "
                >
                  {{ field.label }}
                </div>
              </div>

              <!-- More/Less button for non-priority fields -->
              <div
                *ngIf="getFilteredMainEntityNonPriorityFields().length > 0"
                class="expand-option"
                (click)="toggleEntityExpansion(default_data?.entity?.name)"
              >
                <span *ngIf="!expandedEntities[default_data?.entity?.name]">
                  + {{ getFilteredMainEntityNonPriorityFields().length }} more
                  fields
                </span>
                <span *ngIf="expandedEntities[default_data?.entity?.name]">
                  - Show less
                </span>
              </div>
            </div>

            <!-- Child Entity Groups -->
            <div *ngFor="let childData of default_data?.child_data">
              <div
                *ngIf="!childData.default && shouldShowEntity(childData.label)"
              >
                <div class="entity-header">{{ childData.label }}</div>

                <!-- Priority fields for child entity -->
                <div
                  *ngFor="
                    let field of getFilteredChildEntityPriorityFields(
                      childData.entity_name
                    )
                  "
                  class="field-option priority-field"
                  (click)="
                    selectFieldWithFilter(
                      childData.field_name,
                      field.name,
                      field.label,
                      filter
                    )
                  "
                  [class.selected]="
                    isSelected(childData.field_name, field.name, filter)
                  "
                >
                  <span class="star">★</span> {{ field.label }}
                </div>

                <!-- Non-priority fields for child entity (when expanded) -->
                <div *ngIf="expandedEntities[childData.field_name]">
                  <div
                    *ngFor="
                      let field of getFilteredChildEntityNonPriorityFields(
                        childData.entity_name
                      )
                    "
                    class="field-option"
                    (click)="
                      selectFieldWithFilter(
                        childData.field_name,
                        field.name,
                        field.label,
                        filter
                      )
                    "
                    [class.selected]="
                      isSelected(childData.field_name, field.name, filter)
                    "
                  >
                    {{ field.label }}
                  </div>
                </div>

                <!-- More/Less button for child entity -->
                <div
                  *ngIf="
                    getFilteredChildEntityNonPriorityFields(
                      childData.entity_name
                    ).length > 0
                  "
                  class="expand-option"
                  (click)="toggleEntityExpansion(childData.field_name)"
                >
                  <span *ngIf="!expandedEntities[childData.field_name]">
                    +
                    {{
                      getFilteredChildEntityNonPriorityFields(
                        childData.entity_name
                      ).length
                    }}
                    more fields
                  </span>
                  <span *ngIf="expandedEntities[childData.field_name]">
                    - Show less
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </nz-col>
      <nz-col [nzSpan]="12">
        <nz-select
          (ngModelChange)="set_key2value($event, filter)"
          [ngModel]="key2value(filter)"
          class="w_100"
          nzPlaceHolder="Select field"
        >
          <ng-container
            *ngFor="let item of getOperators(filter?.key1, filter.entity_name)"
          >
            <nz-option [nzLabel]="item.label" [nzValue]="item.value"></nz-option
          ></ng-container>
        </nz-select>
      </nz-col>
      <nz-col [nzSpan]="12">
        <ng-container
          *ngIf="
            filter.key2 !== '$null' &&
            filter.key2 !== '$nnull' &&
            filter.key2 !== '$has' &&
            filter.key2 !== '$has_not'
          "
        >
          <ng-container
            *ngIf="filter.key2 === '$inc' || filter.key2 === '$ninc'"
          >
            <div
              style="
                display: flex;
                align-items: center;
                column-gap: 10px;
                width: 100%;
              "
            >
              <input
                [ngModel]="set_value(filter)"
                (input)="update_includes(filter, $event)"
                nz-input
              />
              <img
                src="../../../../assets/images/icons/blueInfoIcon.svg"
                class="c_pointer"
                nz-tooltip
                [nzTooltipOverlayClassName]="'info_tool_tip_container'"
                [nzTooltipTitle]="'Values required in a comma separated format'"
                nzTooltipPlacement="top"
              />
            </div>
            <ng-container *ngIf="isScriptExist(filter.key3)">
              <div class="error_text_style">{{ script_error_text }}</div>
            </ng-container>
          </ng-container>
          <ng-container
            *ngIf="filter.key2 !== '$inc' && filter.key2 !== '$ninc'"
          >
            <ng-template
              [ngTemplateOutlet]="valueOutlet"
              [ngTemplateOutletContext]="{ filter: filter }"
            ></ng-template>
          </ng-container>
        </ng-container>
      </nz-col>
      <nz-col [nzSpan]="12" class="text-end color_blue f-12 fw-400">
        @if(show_delete(filters)){
          <span class="cPointer" (click)="filters.splice(i, 1)" >Delete</span>
        }@else{
           <span class="cPointer" (click)="resetFilter()" >Delete</span>
        }
      </nz-col>
    </nz-row>
  </ng-container>
  <ng-container *ngIf="Array.isArray(filter)">
    <nz-row [nzGutter]="16" [nzAlign]="'bottom'" class="rowGap">
      <nz-col [nzSpan]="24" class="text-center">
        <ng-container *ngIf="i != 0">
          <nz-switch
            class="mt-15"
            [(ngModel)]="initialSetFilter"
            nzCheckedChildren="AND"
            nzUnCheckedChildren="OR"
            [disabled]="i > 1"
            (ngModelChange)="changeOperatorAdd($event, i)"
          ></nz-switch>
        </ng-container>
      </nz-col>
      <nz-col [nzSpan]="24">
        <div
          style="
            background-color: rgb(247, 248, 249);
            padding: 10px;
            border-radius: 15px;
          "
        >
          <ng-container *ngFor="let item of filter; let j = index">
            <ng-container *ngIf="!Array.isArray(item)">
              <nz-row [nzGutter]="16" [nzAlign]="'bottom'" class="rowGap">
                <nz-col [nzSpan]="24" class="text-center">
                  <ng-container *ngIf="j == 0">
                    <div style="min-width: 100px" class="f-12"></div>
                  </ng-container>
                  <ng-container *ngIf="j !== 0">
                    <nz-switch
                      style="min-width: 100px"
                      class="w_100 mt-15"
                      [ngModel]="!initialSetFilter"
                      nzCheckedChildren="AND"
                      nzUnCheckedChildren="OR"
                      [disabled]="true"
                      (ngModelChange)="changegroupOperatorAdd($event, i, j)"
                    ></nz-switch>
                  </ng-container>
                </nz-col>
                <nz-col [nzSpan]="12">
                  <app-filter-select-entity-field
                    [default_data]="default_data"
                    [filter]="item"
                    [filters]="filters"
                  />
                </nz-col>

                <nz-col [nzSpan]="12">
                  <nz-select
                    class="w_100"
                    (ngModelChange)="set_key2value($event, item)"
                    [ngModel]="key2value(item)"
                    nzPlaceHolder="Select field"
                  >
                    <ng-container
                      *ngFor="
                        let item of getOperators(item?.key1, item.entity_name)
                      "
                    >
                      <nz-option
                        [nzLabel]="item.label"
                        [nzValue]="item.value"
                      ></nz-option
                    ></ng-container>
                  </nz-select>
                </nz-col>
                <nz-col
                  [nzSpan]="12"
                  *ngIf="
                    item.key2 !== '$null' &&
                    item.key2 !== '$nnull' &&
                    item.key2 !== '$has' &&
                    item.key2 !== '$has_not'
                  "
                >
                  <ng-container
                    *ngIf="item.key2 === '$inc' || item.key2 === '$ninc'"
                  >
                    <div
                      style="
                        width: 100%;
                        display: flex;
                        align-items: center;
                        column-gap: 10px;
                      "
                    >
                      <input
                        [ngModel]="set_value(item)"
                        (input)="update_includes(item, $event)"
                        nz-input
                      />
                      <img
                        src="../../../../assets/images/icons/blueInfoIcon.svg"
                        class="c_pointer"
                        nz-tooltip
                        [nzTooltipOverlayClassName]="'info_tool_tip_container'"
                        [nzTooltipTitle]="
                          'Values required in a comma separated format'
                        "
                        nzTooltipPlacement="top"
                      />
                    </div>
                    <ng-container *ngIf="isScriptExist(item.key3)">
                      <div class="error_text_style">
                        {{ script_error_text }}
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container
                    *ngIf="item.key2 !== '$inc' && item.key2 !== '$ninc'"
                  >
                    <ng-template
                      [ngTemplateOutlet]="valueOutlet"
                      [ngTemplateOutletContext]="{ filter: item }"
                    ></ng-template>
                  </ng-container>
                </nz-col>
                <nz-col [nzSpan]="12" class="text-end color_blue f-12 fw-400">
                  <span
                    class="cPointer"
                    (click)="filter.splice(j, 1)"
                    *ngIf="show_delete(filter)"
                    >Delete</span
                  >
                </nz-col>
              </nz-row>
            </ng-container>
            <ng-container *ngIf="Array.isArray(item)">
              <nz-row [nzGutter]="16" [nzAlign]="'bottom'" class="rowGap">
                <nz-col [nzSpan]="24" class="text-center">
                  <ng-container *ngIf="j != 0">
                    <nz-switch
                      [ngModel]="!initialSetFilter"
                      nzCheckedChildren="AND"
                      nzUnCheckedChildren="OR"
                      [disabled]="true"
                      class="mt-15"
                    ></nz-switch>
                  </ng-container>
                </nz-col>
                <nz-col [nzSpan]="24">
                  <div
                    style="
                      background-color: #cccccc;
                      padding: 10px;
                      border-radius: 15px;
                    "
                  >
                    <ng-container *ngFor="let child of item; let k = index">
                      <nz-row
                        [nzGutter]="16"
                        [nzAlign]="'bottom'"
                        class="rowGap"
                      >
                        <nz-col [nzSpan]="24" class="text-center">
                          <ng-container *ngIf="k == 0">
                            <div style="min-width: 100px" class="f-12"></div>
                          </ng-container>
                          <ng-container *ngIf="k !== 0">
                            <nz-switch
                              style="min-width: 100px"
                              class="w_100 mt-15"
                              [ngModel]="initialSetFilter"
                              nzCheckedChildren="AND"
                              nzUnCheckedChildren="OR"
                              [disabled]="true"
                            ></nz-switch>
                          </ng-container>
                        </nz-col>

                        <nz-col [nzSpan]="12">
                          <app-filter-select-entity-field
                            [default_data]="default_data"
                            [filter]="child"
                            [filters]="filters"
                          />
                        </nz-col>
                        <nz-col [nzSpan]="12">
                          <nz-select
                            class="w_100"
                            (ngModelChange)="set_key2value($event, child)"
                            [ngModel]="key2value(child)"
                            nzPlaceHolder="Select field"
                          >
                            <ng-container
                              *ngFor="
                                let item of getOperators(
                                  child?.key1,
                                  child.entity_name
                                )
                              "
                            >
                              <nz-option
                                [nzLabel]="item.label"
                                [nzValue]="item.value"
                              ></nz-option
                            ></ng-container>
                          </nz-select>
                        </nz-col>
                        <nz-col
                          [nzSpan]="12"
                          *ngIf="
                            child.key2 !== '$null' &&
                            child.key2 !== '$nnull' &&
                            child.key2 !== '$has' &&
                            child.key2 !== '$has_not'
                          "
                        >
                          <ng-container
                            *ngIf="
                              child.key2 === '$inc' || child.key2 === '$ninc'
                            "
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                column-gap: 10px;
                                width: 100%;
                              "
                            >
                              <input
                                [ngModel]="set_value(child)"
                                (input)="update_includes(child, $event)"
                                nz-input
                              />
                              <img
                                src="../../../../assets/images/icons/blueInfoIcon.svg"
                                class="c_pointer"
                                nz-tooltip
                                [nzTooltipOverlayClassName]="
                                  'info_tool_tip_container'
                                "
                                [nzTooltipTitle]="
                                  'Values required in a comma separated format'
                                "
                                nzTooltipPlacement="top"
                              />
                            </div>
                            <ng-container *ngIf="isScriptExist(child.key3)">
                              <div class="error_text_style">
                                {{ script_error_text }}
                              </div>
                            </ng-container>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              child.key2 !== '$inc' && child.key2 !== '$ninc'
                            "
                          >
                            <ng-template
                              [ngTemplateOutlet]="valueOutlet"
                              [ngTemplateOutletContext]="{ filter: child }"
                            ></ng-template>
                          </ng-container>
                        </nz-col>
                        <nz-col
                          [nzSpan]="12"
                          class="text-end color_blue f-12 fw-400"
                        >
                          <span
                            class="cPointer"
                            (click)="item.splice(k, 1)"
                            *ngIf="show_delete(item)"
                            >Delete</span
                          >
                        </nz-col>
                      </nz-row>
                    </ng-container>
                    <div class="more_option_container">
                      <div
                        (click)="addNewChildFilter(i, j)"
                        class="option_style"
                      >
                        ++Filter
                      </div>
                      <div (click)="clearChildGroup(i, j)" class="option_style">
                        Clear Group
                      </div>
                    </div>
                  </div>
                </nz-col>
              </nz-row>
            </ng-container>
          </ng-container>
          <div class="more_option_container">
            <div (click)="addNewGroupFilter(i)" class="option_style">
              ++Filter
            </div>
            <div (click)="addChildGroup(i)" class="option_style">++Group</div>
            <div (click)="clearGroup(i)" class="option_style">Clear Group</div>
          </div>
        </div>
      </nz-col>
    </nz-row>
  </ng-container>
</ng-container>
<div class="more_option_container">
  <div (click)="addNewFilter()" class="option_style">++Filter</div>
  <div (click)="addGroup()" class="option_style">++Group</div>
</div>
<ng-template #valueOutlet let-filter="filter">
  <ng-container
    *ngIf="
      findItsDataTypeValue(
        filter.key1,
        filter.entity_name,
        filter.key2
      ) as column;
      else default
    "
  >
    <ng-container *ngIf="filter.key2 === '$btw' && filter?.key3?.type">
      <nz-row [nzGutter]="10" [nzAlign]="'middle'">
        <nz-col [nzSpan]="10">
          <ng-container
            *ngIf="
              filter.key3.type === 'string' && column?.datatype === 'datetime'
            "
          >
            <nz-date-picker
              style="width: 100%; height: 37px"
              [(ngModel)]="filter.key3.from"
              [nzAllowClear]="false"
              [nzShowTime]="{ nzFormat: 'HH:mm:ss', nzUse12Hours: false }"
              [nzFormat]="'dd-MM-yyyy HH:mm:ss'"
              [nzPlaceHolder]="'dd-MM-yyyy HH:mm:ss'"
            ></nz-date-picker>
          </ng-container>
          <ng-container
            *ngIf="
              filter.key3.type === 'string' && column?.datatype !== 'datetime'
            "
          >
            <nz-date-picker
              style="width: 100%; height: 37px"
              [(ngModel)]="filter.key3.from"
              [nzAllowClear]="false"
            ></nz-date-picker>
          </ng-container>
          <ng-container *ngIf="filter.key3.type === 'number'">
            <input
              [(ngModel)]="filter.key3.from"
              nz-input
              type="number"
              class="w_100"
            />
          </ng-container>
        </nz-col>
        <nz-col [nzSpan]="4">to</nz-col>
        <nz-col [nzSpan]="10">
          <ng-container
            *ngIf="
              filter.key3.type === 'string' && column?.datatype === 'datetime'
            "
          >
            <nz-date-picker
              style="width: 100%; height: 37px"
              [(ngModel)]="filter.key3.to"
              [nzAllowClear]="false"
              [nzShowTime]="{ nzFormat: 'HH:mm:ss', nzUse12Hours: false }"
              [nzFormat]="'dd-MM-yyyy HH:mm:ss'"
              [nzPlaceHolder]="'dd-MM-yyyy HH:mm:ss'"
            ></nz-date-picker>
          </ng-container>
          <ng-container
            *ngIf="
              filter.key3.type === 'string' && column?.datatype !== 'datetime'
            "
          >
            <nz-date-picker
              style="width: 100%; height: 37px"
              [(ngModel)]="filter.key3.to"
              [nzAllowClear]="false"
            ></nz-date-picker>
          </ng-container>
          <ng-container *ngIf="filter.key3.type === 'number'">
            <input
              [(ngModel)]="filter.key3.to"
              nz-input
              type="number"
              class="w_100"
            />
          </ng-container>
        </nz-col>
      </nz-row>
    </ng-container>
    <ng-container *ngIf="filter.key2 !== '$btw'">
      <div [ngSwitch]="column.datatype">
        <ng-container *ngSwitchCase="'textbox'">
          <ng-container
            *ngIf="
              filter.key2 === '$in' || filter.key2 === '$nin';
              else normalTextboxInput
            "
          >
            <div
              #multiDropdownContainer
              class="select_box_wrapper"
              style="background: white !important"
            >
              <div
                multiDropdown
                #formElement="multiDropdown"
                #multiDropdown="multiDropdown"
                [default_width]="
                  multiDropdownContainer.getBoundingClientRect().width
                "
                [meta_data]="this.default_data?.meta_data"
                [exe_api_payload_all_field]="exe_api_payload_all_field"
                [rowValue]="filter.key3 || []"
                [fieldProperties]="column"
                (valueChange)="
                  inputValueChange($event, column, multiDropdown, filter)
                "
                class="dropdown-multi-select"
              ></div>
            </div>
          </ng-container>
          <ng-template #normalTextboxInput>
            <div class="input-wrapper">
              <input
                #formElement="customInput"
                (valueChange)="inputValueChange($event, column, input, filter)"
                [fieldLabel]="column.label"
                customInput
                #input="customInput"
                [rowValue]="filter.key3"
                [fieldProperties]="column"
                [columnName]="column.name"
                [datatype]="column.datatype"
                type="search"
                class="w100 textboxclass"
                style="cursor: text"
              />
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'number'">
          <div class="input-wrapper">
            <input
              #formElement="customInput"
              (valueChange)="inputValueChange($event, column, input, filter)"
              customInput
              #input="customInput"
              [rowValue]="filter.key3"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9.]+/g, '')"
              type="search"
              class="w100 textboxclass text-right"
            />
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'currency'">
          <div class="input-wrapper">
            <input
              #formElement="customInput"
              (valueChange)="inputValueChange($event, column, input, filter)"
              customInput
              #input="customInput"
              [rowValue]="filter.key3"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9.]+/g, '')"
              type="search"
              class="w100 textboxclass text-right"
            />
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'email'">
          <ng-container
            *ngIf="
              filter.key2 === '$in' || filter.key2 === '$nin';
              else normalEmailInput
            "
          >
            <div
              #multiDropdownContainer
              class="select_box_wrapper"
              style="background: white !important"
            >
              <div
                multiDropdown
                #formElement="multiDropdown"
                #multiDropdown="multiDropdown"
                [default_width]="
                  multiDropdownContainer.getBoundingClientRect().width
                "
                [meta_data]="this.default_data?.meta_data"
                [exe_api_payload_all_field]="exe_api_payload_all_field"
                [rowValue]="filter.key3 || []"
                [fieldProperties]="column"
                (valueChange)="
                  inputValueChange($event, column, multiDropdown, filter)
                "
                class="dropdown-multi-select"
              ></div>
            </div>
          </ng-container>
          <ng-template #normalEmailInput>
            <div class="input-wrapper">
              <input
                #formElement="customInput"
                [fieldLabel]="column.label"
                (valueChange)="inputValueChange($event, column, input, filter)"
                customInput
                #input="customInput"
                [rowValue]="filter.key3"
                [fieldProperties]="column"
                [columnName]="column.name"
                [datatype]="column.datatype"
                type="search"
                class="w100 textboxclass"
                style="cursor: text"
              />
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'location'">
          <div class="input-wrapper">
            <input
              #formElement="customInput"
              [fieldLabel]="column.label"
              customInput
              (valueChange)="inputValueChange($event, column, input, filter)"
              #input="customInput"
              [rowValue]="filter.key3"
              [fieldProperties]="column"
              [columnName]="column.name"
              [datatype]="column.datatype"
              type="search"
              class="w100 textboxclass"
              style="cursor: text"
            />
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'website'">
          <ng-container
            *ngIf="
              filter.key2 === '$in' || filter.key2 === '$nin';
              else normalWebsiteInput
            "
          >
            <div
              #multiDropdownContainer
              class="select_box_wrapper"
              style="background: white !important"
            >
              <div
                multiDropdown
                #formElement="multiDropdown"
                #multiDropdown="multiDropdown"
                [default_width]="
                  multiDropdownContainer.getBoundingClientRect().width
                "
                [meta_data]="this.default_data?.meta_data"
                [exe_api_payload_all_field]="exe_api_payload_all_field"
                [rowValue]="filter.key3 || []"
                [fieldProperties]="column"
                (valueChange)="
                  inputValueChange($event, column, multiDropdown, filter)
                "
                class="dropdown-multi-select"
              ></div>
            </div>
          </ng-container>
          <ng-template #normalWebsiteInput>
            <div class="input-wrapper">
              <input
                #formElement="customInput"
                [fieldLabel]="column.label"
                (valueChange)="inputValueChange($event, column, input, filter)"
                customInput
                #input="customInput"
                [rowValue]="filter.key3"
                [fieldProperties]="column"
                [columnName]="column.name"
                [datatype]="column.datatype"
                type="search"
                class="w100 textboxclass"
                style="cursor: text"
              />
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'dropdown_single_select'">
          <div
            class="select_box_wrapper"
            style="background: white !important"
            #dropdown_single
          >
            <div
              [default_width]="dropdown_single.getBoundingClientRect().width"
              [meta_data]="this.default_data?.meta_data"
              [exe_api_payload_all_field]="exe_api_payload_all_field"
              #formElement="multiDropdown"
              [rowValue]="filter.key3 || []"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, multiDropdown, filter)
              "
              multiDropdown
              #multiDropdown="multiDropdown"
              class="dropdown-multi-select"
            ></div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'priority'">
          <div
            #priority
            class="select_box_wrapper"
            style="background: white !important"
          >
            <div
              [default_width]="priority.getBoundingClientRect().width"
              #formElement="multiDropdown"
              [rowValue]="
                Array.isArray(filter.key3) ? filter.key3 : [filter.key3]
              "
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, multiDropdown, filter)
              "
              multiDropdown
              #multiDropdown="multiDropdown"
              class="dropdown-multi-select"
            ></div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'status'">
          <div
            #status
            class="select_box_wrapper"
            style="background: white !important"
          >
            <div
              [default_width]="status.getBoundingClientRect().width"
              #formElement="multiDropdown"
              [rowValue]="filter.key3 || []"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, multiDropdown, filter)
              "
              multiDropdown
              #multiDropdown="multiDropdown"
              class="dropdown-multi-select"
            ></div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'dropdown_multi_select'">
          <div
            #dropdown_multi_select
            class="select_box_wrapper"
            style="background: white !important"
          >
            <div
              [default_width]="
                dropdown_multi_select.getBoundingClientRect().width
              "
              [meta_data]="this.default_data?.meta_data"
              [exe_api_payload_all_field]="exe_api_payload_all_field"
              #formElement="multiDropdown"
              [rowValue]="filter.key3 || []"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, multiDropdown, filter)
              "
              multiDropdown
              #multiDropdown="multiDropdown"
              class="dropdown-multi-select"
            ></div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'tag'">
          <div
            class="select_box_wrapper"
            style="background: white !important"
            #tag
          >
            <div
              [default_widths]="tag.getBoundingClientRect().width"
              #formElement="tagDropdown"
              [rowValue]="filter.key3 || []"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, tagDropdown, filter)
              "
              tagDropdown
              #tagDropdown="tagDropdown"
              style="
                text-align: center;
                padding: 5px;
                font-size: 12px;
                white-space: nowrap;
              "
            ></div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'people'">
          <div
            #people
            class="people_box_wrapper"
            style="background: white !important"
          >
            <div
              [default_widths]="people.getBoundingClientRect().width"
              #formElement="customPeople"
              [rowValue]="filter.key3 || []"
              [columnName]="column.name"
              [datatype]="column.datatype"
              [fieldLabel]="column.label"
              [fieldProperties]="column"
              [useLoggedInTextLabel]="true"
              (valueChange)="
                inputValueChange($event, column, customPeople, filter)
              "
              customPeople
              #customPeople="customPeople"
              class="custom-people"
              [meta_data]="this.default_data?.meta_data"
            ></div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
          <ng-container [ngTemplateOutlet]="datePicker"></ng-container>
          <ng-template #datePicker>
            <nz-date-picker
              #formElement="customDate"
              customDate
              #customDate="customDate"
              style="width: 100%; height: 37px"
              [nzPlaceHolder]="column.dateFormat"
              [nzFormat]="column.dateFormat"
              [ngModel]="filter.key3"
              [rowValue]="filter.key3"
              [fieldProperties]="column"
              (nzOnOpenChange)="customDate.runValidator()"
              [nzDisabledDate]="customDate.disabledDate"
              (ngModelChange)="customDate.dateValueChange($event)"
              [nzAllowClear]="false"
              (valueChange)="
                inputValueChange($event, column, customDate, filter)
              "
            ></nz-date-picker>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'checkbox'">
        </ng-container>
        <ng-container *ngSwitchCase="'rating'">
          <div
            #formElement="customRatings"
            style="text-align: center"
            customRatings
            #customRatings="customRatings"
            [fieldProperties]="column"
            [rowValue]="filter.key3 || 0"
            (valueChange)="
              inputValueChange($event, column, customRatings, filter)
            "
          ></div>
          -
        </ng-container>
        <ng-container *ngSwitchCase="'progress'">
          <div
            #formElement="customProgress"
            customProgress
            #customProgress="customProgress"
            [fieldProperties]="column"
            [rowValue]="filter.key3 || 0"
            style="
              text-align: center;
              display: flex;
              justify-content: space-between;
              gap: 5px;
              align-items: center;
            "
          >
            <div style="width: 100%">
              <nz-slider
                #slider
                [nzMax]="column.endValue"
                [nzMin]="column.startValue"
                [ngModel]="filter.key3"
                (nzOnAfterChange)="
                  customProgress.progressBarValueChange($event, slider)
                "
              ></nz-slider>
            </div>
            <div>{{ slider.value }}%</div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'attachment'">
          <div
            #formElement="customFileAttachment"
            class="select_box_wrapper"
            style="justify-content: center"
            [fieldProperties]="column"
            [rowValue]="filter.key3 || []"
            (valueChange)="
              inputValueChange($event, column, customFileAttachment, filter)
            "
            customFileAttachment
            #customFileAttachment="customFileAttachment"
          ></div>
        </ng-container>
        <ng-container *ngSwitchCase="'time'">
          <div class="select_box_wrapper f-12" #time>
            <div
              [default_size]="time.getBoundingClientRect().width"
              [from_filter]="true"
              #formElement="time"
              time
              #time="time"
              [rowValue]="filter.key3"
              [fieldProperties]="column"
              (valueChange)="
                inputValueChange($event, column, formElement, filter)
              "
            ></div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'datetime'">
          <nz-date-picker
            style="width: 100%; height: 37px"
            [nzShowTime]="{ nzFormat: 'HH:mm:ss', nzUse12Hours: false }"
            [nzPlaceHolder]="
              getAngularDateFormat(
                column.dateTimeFormat || 'dd-MM-yyyy HH:mm:ss'
              )
            "
            [nzFormat]="
              getAngularDateFormat(
                column.dateTimeFormat || 'dd-MM-yyyy HH:mm:ss'
              )
            "
            [ngModel]="filter.__dtModel ?? getDateTimeModel(filter.key3)"
            (ngModelChange)="onDateTimeModelChange($event, filter)"
            (nzOnOk)="onDateTimeModelChange($event, filter)"
            [nzAllowClear]="false"
          >
          </nz-date-picker>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <input [(ngModel)]="filter.key3" nz-input />
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #default>
    <input
      [(ngModel)]="filter.key3"
      nz-input
      nzPlaceHolder="in"
      class="w_100"
    />
  </ng-template>
</ng-template>

<style>
  .autocomplete-dropdown {
    position: absolute;
    background: white;
    border: 1px solid #ccc;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .autocomplete-dropdown li {
    padding: 8px 12px;
    cursor: pointer;
  }

  .autocomplete-dropdown li:hover {
    background: #f0f0f0;
  }
</style>
